import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";
import { IUser } from "../../Typings/User";

export const useFeatureToggles = (user: any) => {
  const launchDarklyClient = useLDClient();

  //updates the context once a user has logged in
  useEffect(() => {
    if (user) {
      let currentUser: IUser = {
        id: user["http://nasrecruitment.io/activateId"],
        email: user.email,
        name: user.name,
      };

      if (launchDarklyClient) {
        launchDarklyClient.identify({
          kind: "user",
          key: currentUser?.id,
          name: currentUser?.name,
          email: currentUser?.email,
        });
      }
    }
  }, [user, user?.id, user?.email, user?.name, launchDarklyClient]);

  return;
};
